import { render, staticRenderFns } from "./singleShopSplitHistList.vue?vue&type=template&id=15e4f388&scoped=true"
import script from "./singleShopSplitHistList.vue?vue&type=script&lang=js"
export * from "./singleShopSplitHistList.vue?vue&type=script&lang=js"
import style0 from "./singleShopSplitHistList.vue?vue&type=style&index=0&id=15e4f388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e4f388",
  null
  
)

export default component.exports